<template>
  <path
    d="M5 18.0002C5 18.5502 5.45 19.0002 6 19.0002H18C18.55 19.0002 19 18.5502 19 18.0002C19 17.4502 18.55 17.0002 18 17.0002H6C5.45 17.0002 5 17.4502 5 18.0002ZM9.5 12.8002H14.5L15.16 14.4002C15.31 14.7602 15.66 15.0002 16.05 15.0002C16.74 15.0002 17.2 14.2902 16.93 13.6602L13.05 4.69018C12.87 4.27018 12.46 4.00018 12 4.00018C11.54 4.00018 11.13 4.27018 10.95 4.69018L7.07 13.6602C6.8 14.2902 7.27 15.0002 7.96 15.0002C8.35 15.0002 8.7 14.7602 8.85 14.4002L9.5 12.8002ZM12 5.98018L13.87 11.0002H10.13L12 5.98018Z"
  />
</template>
